import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { showMessage } from '../../../helpers/message';

// Components
import AutoDeFiscalizacao from '../AutoDeFiscalizacao';

// API
import fiscalizacao_api from '../../../api/fiscalizacao_api';

export default function ImpressaoFichaFiscalizacaoCompleta() {
    const location = useLocation();
    const hash = new URLSearchParams(location.search).get('hash');

    const [fiscalizacao, setFiscalizacao] = useState(null);

    useEffect(() => {
        if (!hash) return;

        fiscalizacao_api.GetFiscalizacaoHash(hash)
            .then(({ data }) => setFiscalizacao(data))
            .catch(error => showMessage("Erro", error?.message ?? "Erro na operação!", "error", null));
    }, [hash]);

    if (!fiscalizacao) return <></>;

    return <AutoDeFiscalizacao fichaExterna={fiscalizacao} />;
}
